export const last = (array: string[] | number[]) => array[array.length - 1];
